module.exports = __webpack_public_path__ + "img/login-illustration.c1a86ee5.png";